import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import Contact from "../../components/Contact/Contact";

export default function ERP() {
  // Data for AlternatingImageText sections
  const alternatingSections = [
    {
      title: "A committed team with decades of experience",
      description: `We have over 25 years' experience implementing and supporting the delivery of ERP solutions in Europe, Africa and Asia for many industries such as Oil and Gas, Manufacturing, Life Sciences, Professional Services, Real Estate, and Retail.\n\nOur focus is delivering value add projects for our clients. Over the years we have implemented several ERP products including Microsoft Dynamics D365 (AX), Business Central (NAV), Customer Engagement (CRM), Workday, and NetSuite. We also provide Interim Resources and Remote Helpdesk Support.`,
      imageSrc: "/clapping.jpg",
      imageAlt: "ERP Expertise",
    },
    {
      title: "Driving Business Goals With Our Project Solutions",
      description: `August Twenty will work with you and help you manage your complete project life cycle. We will assist you in defining and establishing your project goals and objectives; so that they meet and fit the culture and needs of your business.\n\nWith our emphasis on communication and risk management, we will ensure a smooth transition back to you – our client.\n\nUsing an established network of associates, we can help you develop and maintain relationships with your partners and collaborators.`,
      imageSrc: "/Analytics.png",
      imageAlt: "Implementation Process",
    },
  ];

  // Data for ServicesSection (unchanged)
  const servicesData = [
    {
      id: 1,
      image: "/erp1.jpg",
      title: "Programme and Project Management",
      description: "Our Programme and Project Management offering includes:",
      bullets: [
        "Project Management Office",
        "Project Audit",
        "Change Management",
      ],
    },
    {
      id: 2,
      image: "/erp2.jpg",
      title: "ERP Implementation & Consulting",
      description: "With over 100 ERP solutions successfully delivered, our team have the breadth and depth to ensure your implementation is a success.",
      description2: "In addition to Project Management resources, we can place resources to enable the delivery of Upgrades,  Business Intelligence / KPI reporting, Data Migration, Training, and Testing.",
    },
    {
      id: 3,
      image: "/erp3.jpg",
      title: "Remote Helpdesk and Support Management",
      description: "We offer tailored remote helpdesk support, designed to meet your business' specific needs.",
      bullets: [
        "Technical support & troubleshooting",
        "Regular system updates & patches",
        "Performance monitoring & optimisation",
        "Security audits & compliance",
        "Backup & disaster recovery"
      ]
    }
  ];

  return (
    <>
      <HeroAlternative 
        title="Our ERP Solutions"
        description="Specialising in ERP Solutions – Implementation to Delivery, August Twenty offers tailored Professional Services."
        imageSrc="/girl_looking.jpg"
      />
      
      {/* Now passing the required sections prop */}
      <AlternatingImageText sections={alternatingSections} />
      
      <ServicesSection 
        eyebrow="Services we provide"
        title="Reliable expertise to drive your greatest success"
        services={servicesData}
      />
      
      <Contact />
    </>
  );
}